import { render } from "./settingsAside.vue?vue&type=template&id=4c85505c&scoped=true"
import script from "./settingsAside.vue?vue&type=script&lang=js"
export * from "./settingsAside.vue?vue&type=script&lang=js"

import "./settingsAside.vue?vue&type=style&index=0&id=4c85505c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c85505c"]])

export default __exports__